import { render, staticRenderFns } from "./_popover.vue?vue&type=template&id=57bab55c"
import script from "./_popover.vue?vue&type=script&lang=js"
export * from "./_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports